import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { i18n } from '@/lang'

const app = createApp(App)

import autoReg from '@/components/index.js'
autoReg.installCom(app)

app.use(i18n)

app.use(router).mount('#app')
